module.exports = {"courses":[],"designateLocation":true,"updated":"2024-07-12 07:45:55 -0700"}


//////////////////
// WEBPACK FOOTER
// ./src/data/code/course-schedule.json
// module id = 1946
// module chunks = 223245780099124